import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${colors.black1};
  padding: 20px;

  .content {
    text-align: center;
    max-width: 600px;
    padding: 40px;
    border-radius: 10px;
    background-color: ${colors.white};
    box-shadow: 0 4px 6px ${colors.black4};
  }

  .errorCode {
    font-size: 120px;
    font-weight: bold;
    color: ${colors.red};
    line-height: 1;
    margin-bottom: 20px;
    text-shadow: 3px 3px 0 ${colors.black4};
  }

  .title {
    font-size: 32px;
    font-weight: 600;
    color:${colors.lightBlue};
    margin: 0 0 15px 0;
  }

  .message {
    font-size: 18px;
    color: ${colors.lightBlue};
    line-height: 1.6;
    margin-bottom: 30px;
  }

  .homeLink {
    display: inline-block;
    padding: 12px 30px;
    background-color: ${colors.darkGrey};
    color: ${colors.white};
    text-decoration: none;
    border-radius: 5px;
    font-weight: 500;
    transition: all 0.3s ease;
    font-size: 16px;
    border: 2px solid ${colors.darkGrey};
    cursor: pointer;
    :hover {
      background-color: ${colors.white};
      color: ${colors.darkGrey};
    }
  }
`;